module.exports = __webpack_public_path__ + "static/media/baijiale_pc_game.25944fd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/baijiale_pc_game.mp4
// module id = WbPu
// module chunks = 0